<template>
  <app-base-main parentTable>
    <template #filter-group>
      <app-filter-group
          @reset="$gjReset"
          @query="$gjNoticeQuery"
      >
        <gj-search-input
            v-model="filter.code"
            placeholder="供应商编码/名称"
            width="140px"
        ></gj-search-input>

        <gj-select
            v-model="filter.status"
            :options="option.disableLowerCaseOption"
            placeholder="全部状态"
        ></gj-select>
        <gj-select
            v-model="filter.settlementWay"
            :options="option.settlementType"
            placeholder="结算方式"
        ></gj-select>
        <gj-select-input
            v-model="filter.keyword"
            :options="[
            {id: 'buyer', text: '采购员'},
            {id: 'crateUser', text: '创建人'},
            {id: 'contact', text: '联系人'},
          ]"
            :placeholder="['', '请输入姓名']"
        ></gj-select-input>
        <gj-date-picker
            v-model="filter.date"
            type="daterange"
        ></gj-date-picker>
      </app-filter-group>
    </template>
    <template #operate-group>
      <gj-button v-if="$permission('supplier:add')" type="primary" @click="openEditSupplier(null), userGuideTemporarilyClosed()">添加</gj-button>
      <gj-dropdown-button  v-if="$permission('supplier:add') || $permission('supplier:addQuote')" ref="supplierImport">
      <!-- <gj-dropdown-button  v-if="$permission('supplier:add') || $permission('supplier:addQuote')" ref="supplier_import" id="supplier_import" > -->
        导入
        <template #dropdown>
          <gj-dropdown-item @click="importSupplier(), userGuideTemporarilyClosed()" :disabled="userGuideState" v-if="$permission('supplier:add')">导入供应商</gj-dropdown-item>
          <gj-dropdown-item @click="importSupplierQuotedPrice(), userGuideTemporarilyClosed()" :disabled="userGuideState" v-if="$permission('supplier:addQuote')">导入报价</gj-dropdown-item>
        </template>
      </gj-dropdown-button>
      <template v-if="$permission('supplier:enable')">
        <gj-button
            :disabled="noSelect || selectedSomeIs('status', option.disableLowerCaseOption[1].id)"
            @click="ableSupplier(option.disableLowerCaseOption[1].id, selectedRows.map(v => v.id))">停用</gj-button>
        <gj-button
            :disabled="noSelect || selectedSomeIs('status', option.disableLowerCaseOption[0].id)"
            @click="ableSupplier(option.disableLowerCaseOption[0].id, selectedRows.map(v => v.id))">启用</gj-button>
      </template>
    </template>
    <template #tool-group>
      <gj-tool-group
          :download="$permission('supplier:export')"
          download-url="/supply/supplier/export"
          :download-params="globalParams"
          :sort-gjtable="$refs.gjTable"
          setting :table-name="name" :table-columns="columns"
          help
      ></gj-tool-group>
    </template>
    <template #table>
      <gj-table
          ref="gjTable"
          adaptParent
          :columns="columns"
          :data="tableData"
          :loading="loading"
          :pagination="pagination"
          selection
          @sort-change="$gjSortChange"
          @page-change="$gjNoticeQuery"
      >

        <template v-slot:status="{row}">
          <gj-tag type="text" style="margin-right: 10px" shape="rectangle"
                  :color="row.status | optionColor(disableLowerCaseOption)">
            {{ row.status | optionText(disableLowerCaseOption) }}
          </gj-tag>
        </template>

        <template v-slot:op="{row}">
          <gj-button-group
              type="dropdown-op"
              :config="opBtnConfig(row)"

              
          ></gj-button-group>
        </template>
      </gj-table>
    </template>
    <template v-if="userGuideState " #base-content>
      <new-user-guide-add-supplier 
      ref="newUserGuide" 
      :showSupplierQuote="showSupplierQuote"
      @closeModal="closeModal"
      @taskName="onStartTask"
      >
      </new-user-guide-add-supplier>
    </template>
  </app-base-main>
</template>

<script>
  import {queryMixin, responseMixin, selectionMixin, userGuideMixin} from "@/minxins";
  import ImportSupplier from './modal/supplier-import';
  import ImportSupplierQuotedPrice from './modal/supplier-import-quoted-price';
  import SupplierEdit from './modal/supplier-edit';
  import SupplierAddQuotedPrice from './modal/supplier-add-quoted-price';
  import SupplierDetail from './detail/supplier-detail';
  import NewUserGuideAddSupplier from "./modal/new-user-guide-add-supplier"
  import {isMeaningful} from "@/utils/common";
  import {convertToDate} from "@/utils/date.util";
  import {ableSupplier, deleteSupplier, getSupplierPage} from "@/api/purchase";
  import {disableLowerCaseOption, settlementType} from "@/utils/options";
  import {PURCHASE_GET_ACTIVE_SUPPLIER, PURCHASE_GET_SUPPLIER} from "@/store/action-types";
  import {mapGetters} from "vuex";

  export default {
    name: "supplier-manager",
    mixins: [queryMixin, selectionMixin, responseMixin, userGuideMixin],
    components: { NewUserGuideAddSupplier},
    data() {
      return {
        disableLowerCaseOption,
        name: 'supplierManager',
        tableData: [],
        columns: [
          {id: 'supplierCode', header: '供应商编号', field: 'code', minWidth: '120px', default: true},
          {id: 'name', header: '供应商名称', field: 'name', minWidth: '180px', default: true, overflowLine:1},
          {id: 'settlementWay', header: '结算方式', field: 'option:settlementWay', minWidth: '120px', default: true, options: settlementType},
          {id: 'status', header: '状态', field: 'slot:status', minWidth: '80px', default: true, options: disableLowerCaseOption},
          {id: 'buyer', header: '采购员', field: 'buyer', minWidth: '80px', default: true},
          {id: 'contact', header: '联系人', field: 'contact', minWidth: '80px', default: true},
          {id: 'contactPhone', header: '联系电话', field: 'contactPhone', minWidth: '120px', default: true},
          {id: 'addr', header: '联系地址', field: 'addr', minWidth: '140px', default: true, overflowLine:2},
          {id: 'createUserName', header: '创建人', field: 'createUserName', minWidth: '120px', default: true},
          {id: 'createTime', header: '创建时间', field: 'createTime', minWidth: '160px', default: true},
          {id: 'op', header: '操作', field: 'slot:op', width: '120px', notCustomColumn: true, fixed: 'right'},
        ],
        filter: {
          code: null,
          status: null,
          settlementWay: null,
          keyword: {
            key: 'buyer',
            value: null
          },
          date: null,
        },
        option: {
          settlementType: settlementType,
          disableLowerCaseOption: disableLowerCaseOption,
        },
        opBtnConfig: (row) => [
          {
            label: '编辑',
            show: () => this.$permission('supplier:add'),
            click: () => this.openEditSupplier(row.id)
          },
          {
            label: '报价',
            show: () => this.$permission('supplier:addQuote'),
            click: () => this.openQuotedPriceSupplier(row)
          },
          {
            label: '启用',
            show: () => this.$permission('supplier:enable') && row.status === this.option.disableLowerCaseOption[1].id,
            click: () => this.ableSupplier(this.option.disableLowerCaseOption[0].id, [row.id])
          },
          {
            label: '停用',
            show: () => this.$permission('supplier:enable') && row.status !== this.option.disableLowerCaseOption[1].id,
            click: () => this.ableSupplier(this.option.disableLowerCaseOption[1].id, [row.id])
          },
          {
            label: '删除',
            show: () => this.$permission('supplier:delete'),
            click: () => this.deleteSupplier([row.id])
          },
          {
            label: '详情',
            click: () => this.openDetail(row)
          },
        ],
        notStorage: true,
        isAutoAdAuthModal: true,//是否是引导状态
        showSupplierQuote: false,
        taskName: ''

      }
    },
     computed: {
      ...mapGetters(['userInfo','marketAuthType']),
    },
    created(){


      
    },
    methods: {
      $gjQuery() {
        const params = {
          model: {
            code: this.filter.code,
            name: this.filter.code,
            status: this.filter.status,
            settlementWay: this.filter.settlementWay,
            startCreateTime: isMeaningful(this.filter.date) ? convertToDate(this.filter.date[0]) : null,
            endCreateTime: isMeaningful(this.filter.date) ? convertToDate(this.filter.date[1]) : null,
          },
          ...this.querySort,
          ...this.queryPagination
        };
        params.model[this.filter.keyword.key] = this.filter.keyword.value;
        this.globalParams = params;
        this.loading = true;
        getSupplierPage(params)
          .then((res) => {
            this.pagination = this.getPagination(res);
            this.tableData = res.records;
            this.showSupplierQuote = !this.showSupplierQuote;
          }).complete(() => this.loading = false)
      },
      $gjQueryInitParams() {
        return {
          filter: {
            code: null,
            status: null,
            settlementWay: null,
            keyword: {
              key: 'buyer',
              value: null
            },
            date: null,
          }
        }
      },
      ableSupplier(type, ids) {
        const modal = this.$gjCreate('gj-info-modal', {
          props: {
            title: `${type === this.option.disableLowerCaseOption[1].id ? '停用' : '启用'}确认`,
            content: `是否确定${type === this.option.disableLowerCaseOption[1].id ? '停用' : '启用'}选中的供应商？`,
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              ableSupplier(type, ids)
                .then((res) => {
                  this.$gjResponseHandle(res, () => {
                    this.$gjMessage.success('操作成功');
                    this.$gjNoticeQuery();
                    this.refreshSupplierOptions();
                    modal.$gjDestroy();
                  })
                }).complete(() => modal.confirmLoading = false)
            }
          }
        });
      },
      deleteSupplier(ids) {
        const modal = this.$gjCreate('gj-info-modal', {
          props: {
            title: '删除确认',
            content: '是否确定删除供应商？'
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              deleteSupplier(ids)
                .then((res) => {
                  this.$gjResponseHandle(res, () => {
                    this.$gjMessage.success('操作成功');
                    this.$gjNoticeQuery();
                    this.refreshSupplierOptions();
                    modal.$gjDestroy();
                  })
                }).complete(() => modal.confirmLoading = false)
            }
          }
        })
      },
      importSupplier() {
        this.exitGuide('addSupplier');
        this.isAutoAdAuthModal = true
        this.$gjCreate(ImportSupplier, {
          on: {
            importFileSuccess: () => {
              this.refreshSupplierOptions();
              this.$gjResetPage();
            },
            userGuide: () => {
              if(this.canGoNextStep('addSupplier')){
                this.isAutoAdAuthModal = false;
                // 引导用户
                this.userGuideNextStep(2);
              }
            },
            close: () => {
              // 关闭引导用户
              if (this.isAutoAdAuthModal){
                this.userGuideCancel()
              }
            },
          }
        })
      },
      importSupplierQuotedPrice() {
        this.exitGuide('quotePrice');
        this.isAutoAdAuthModal = true
        this.$gjCreate(ImportSupplierQuotedPrice, {
          on: {
            importFileSuccess: () => {
              this.$gjResetPage();
            },
            userGuide: () => {
              if(this.canGoNextStep('quotePrice')){
                this.isAutoAdAuthModal = false;
                // 引导用户
                this.userGuideNextStep(2)
                this.userGuideOpenDetail();
              }
            },
            close: () => {
              // 关闭引导用户
              if (this.isAutoAdAuthModal){
                this.userGuideCancel()
              }
            },
          }
        })
      },
      openEditSupplier(id) {
        this.exitGuide('addSupplier');
        this.isAutoAdAuthModal = true
        const modal = this.$gjCreate(SupplierEdit, {
          props: {
            id: id,
            hideSureQuote: this.userGuideState && this.$refs.newUserGuide?.taskName
          },

          on: {
            after: (data) => {
              this.$gjNoticeQuery();
              if (isMeaningful(data)) {
                this.openQuotedPriceSupplier(data)
              }
              this.refreshSupplierOptions();
              modal.$gjDestroy();
            },
            userGuide: (state) => {
              if(this.canGoNextStep('addSupplier') ){
                this.isAutoAdAuthModal = false;
                // 引导用户
                this.userGuideNextStep(2);
              }
            },
            close: () => {
              // 关闭引导用户
              if (this.isAutoAdAuthModal){
                this.userGuideCancel()
              }
            },
          }
        })
      },
      openQuotedPriceSupplier(item) {
        this.exitGuide('quotePrice');
        this.isAutoAdAuthModal = true
        this.userGuideTemporarilyClosed()
        this.$gjCreate(SupplierAddQuotedPrice, {
          props: {
            code: item.code,
            name: item.name
          },
          on: {
            userGuide: () => {
              if(this.canGoNextStep('quotePrice')){
                this.isAutoAdAuthModal = false;
                // 引导用户
                this.userGuideNextStep(2)
                this.userGuideOpenDetail();
              }
            },
            close: () => {
              // 关闭引导用户
              if (this.isAutoAdAuthModal){
                this.userGuideCancel()
              }
            },
          }
        })
      },
      exitGuide(taskName){
        if (!this.canGoNextStep(taskName)){
          this.userGuideCancel()
        }
      },
      canGoNextStep(taskName){
        return this.userGuideState && taskName === this.$refs.newUserGuide.taskName
      },
      userGuideOpenDetail(){
        let timeStamp = this.tableData.length > 0 ? 0 : 2000;
        setTimeout(()=>{
          this.isAutoAdAuthModal = true
          this.openDetail(this.tableData[0], 2);
          document.getElementById("dropdown")?.click()
        }, timeStamp)
      },

      openDetail(item, openIndex) {
        // this.isAutoAdAuthModal = true
        this.detailModal =  this.$gjCreate(SupplierDetail, {
          props: {
            id: item.id,
            code: item.code,
            openIndex: openIndex
          },
          on: {
            close: () => {
              // 关闭引导用户
              if (this.isAutoAdAuthModal){
                this.userGuideCancel()
              }
              // this.userGuideCancel()
            },
          }
        })
      },
      refreshSupplierOptions() {
        this.$store.dispatch(PURCHASE_GET_ACTIVE_SUPPLIER);
        this.$store.dispatch(PURCHASE_GET_SUPPLIER);
      },
      closeModal() {
        if(this.detailModal)  {
          this.isAutoAdAuthModal = false; // 是否为主动销毁
          this.detailModal.$gjDestroy();
          this.detailModal = null;
        }
      },
      onStartTask(val){
        if (val === 'addSupplier'){
          this.$refs.supplierImport.$children[0].$children[0].visible = true
        }else if (val === 'quotePrice'){
          setTimeout(()=>{
            if(this.$refs.supplierImport) {
              this.$refs.supplierImport.$children[0].$children[0].visible = true
            }
          },200)
        }
      },
    }
  }
</script>

<style scoped>

</style>
